import React from "react";
import "./reject-request-popup.scss";
import rejectIcon from "../../../assets/icons/rejectIcon.svg";
import { RejectRequestPopupProps } from "./reject-request-props";

/** Popup to confirm rejecting an item with a specific id and label. */
const RejectRequestPopup: React.FC<RejectRequestPopupProps> = ({
  isOpen,
  onClose,
  handleReject,
  rejectId,
  label,
}) => {
  if (!isOpen) return null;

  return (
    <div className="reject-popup-overlay">
      <div className="reject-popup">
        <div className="reject-popup-image-box">
          <div className="reject-popup-image">
            <div className="rejectIcon-background">
              <img src={rejectIcon} alt="reject-icon" />
            </div>
          </div>
        </div>
        <h4 className="reject-title">Reject {label}</h4>
        <p className="reject-message">Would you like to reject this {label}?</p>
        <div className="reject-buttons">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button
            className="reject-button"
            onClick={() => handleReject(rejectId)}
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectRequestPopup;
